import { useEffect, useState } from 'react'

export default function FacturaTotales({ details, dteCode }) {
  const [totals, setTotals] = useState({
    gross: 0, // Sub total (sin descuentos)
    discount: 0, // total descuentos línea a línea
    net: 0, // después de descuentos
    iva: 0,
    grand: 0
  })

  useEffect(() => {
    let gross = 0
    let discount = 0
    for (const item of details) {
      const qty = Number(item.quantity) || 0
      const price = Number(item.unit_price) || 0
      const pct = Number(item.discount_percent) || 0

      const lineGross = qty * price
      const lineDiscount = (lineGross * pct) / 100

      gross += lineGross
      discount += lineDiscount
    }

    const net = gross - discount
    const ivaRate = dteCode === '34' ? 0 : 0.19
    const iva = Math.round(net * ivaRate)
    const grand = net + iva

    setTotals({ gross, discount, net, iva, grand })
  }, [details, dteCode])

  const formatMoney = value => value.toLocaleString('es-CL')

  const ivaPercentLabel = dteCode === '34' ? '0 %' : '19 %'

  return (
    <section className='mt-8'>
      <div className='flex justify-end'>
        <div className='w-full md:w-80 space-y-3 px-2'>
          {/* MONTO NETO */}
          <div className='flex justify-between items-center text-sm py-1'>
            <span className='text-gray-500 font-medium'>Monto Neto</span>
            <span className='text-slate-900 font-semibold'>${formatMoney(totals.net)}</span>
          </div>

          {/* IVA % e Importe */}
          <div className='flex justify-between items-center text-sm py-1'>
            <span className='text-gray-500 font-medium'>IVA ({ivaPercentLabel})</span>
            <span className='text-slate-900 font-semibold'>${formatMoney(totals.iva)}</span>
          </div>

          {/* Separador sutil */}
          <div className='h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent my-2'></div>

          {/* TOTAL FINAL */}
          <div className='flex justify-between items-center py-2'>
            <span className='text-slate-800 font-bold text-base uppercase tracking-tight'>Total</span>
            <span className='text-primary font-black text-xl tracking-tight'>
              ${formatMoney(totals.grand)}
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}
